<template>
  <div class="copy-field-v2 relative">
    <div
      v-if="isCodeBlock"
      dir="ltr"
      class="bg-neutral-100 border border-solid border-neutral-300 rounded-[8px] px-[11px] py-[7px] ltr:pr-24 rtl:pl-24 whitespace-pre overflow-x-auto text-base leading-6 ltr:text-left rtl:text-right text-[#525252]"
      v-text="value"
    />
    <div
      v-else
      class="readonly-v2 w-full flex flex-row items-center"
      :class="[
        compact ? '!h-10' : '',
        copyLabel ? 'ltr:pr-24 rtl:pl-24' : 'ltr:pr-11 rtl:pl-11',
      ]"
    >
      <span
        class="min-w-0 truncate"
        :class="valueColorClass"
        :dir="value ? 'ltr' : null"
        v-text="value || placeholder"
      />
    </div>
    <button-v2
      :variant="copyLabel ? 'ghost' : 'naked'"
      :color="copyLabel ? 'primary' : 'neutral'"
      size="sm"
      icon="content_copy"
      :icon-class="copyLabel ? '' : '!text-[24px] text-neutral-400'"
      class="!absolute"
      :class="buttonClass"
      :disabled="disabled || !value"
      :aria-label="copyLabel || $t('COMPONENTS.CODE.BUTTON_TEXT')"
      @click="onCopy"
    >
      <template v-if="copyLabel">{{ copyLabel }}</template>
    </button-v2>
  </div>
</template>

<script>
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import alertMixin from 'shared/mixins/alertMixin';
import ButtonV2 from './ButtonV2.vue';

export default {
  name: 'CopyFieldV2',
  components: { ButtonV2 },
  mixins: [alertMixin],
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    multiline: { type: Boolean, default: false },
    copyLabel: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    muted: { type: Boolean, default: false },
  },
  computed: {
    isCodeBlock() {
      return this.multiline && !!this.value;
    },
    valueColorClass() {
      if (!this.value) return 'text-neutral-400';
      if (this.muted) return 'text-neutral-300';
      return this.copyLabel ? 'text-[#525252]' : '';
    },
    buttonClass() {
      if (this.copyLabel) return '!h-7 top-2 ltr:right-3 rtl:left-3';
      return [this.compact ? 'top-1' : 'top-1.5', 'ltr:right-2 rtl:left-2'];
    },
  },
  methods: {
    async onCopy() {
      if (!this.value) return;
      try {
        await copyTextToClipboard(this.value);
        this.showAlert(this.$t('COMPONENTS.CODE.COPY_SUCCESSFUL'));
      } catch {
        this.showAlert(this.$t('COMPONENTS.CODE.COPY_FAILED'));
      }
    },
  },
};
</script>
